/**
 * Filters the data
 * @param {Array} models
 * @param {Object} queryParams
 */
export function filter(models, queryParams) {
    // Parses filters from queryParams
    const filters = Object.keys(queryParams)
        .filter(key => key.includes('filter'))
        .map(key => ({
            name: key.replace('filter[', '').replace(']', ''),
            value: queryParams[key],
        }))
        .reduce((accumulator, { name, value }) => {
            accumulator[name] = value;
            return accumulator;
        }, {});


    if (Object.keys(filters).length === 0) {
        return models;
    }

    const filterBy = (field, value) => model => model[field].toLowerCase().includes(value.toLowerCase());

    // Make sure all of the filters match
    models = models.filter((model) => {
        return Object.keys(filters)
            .map(filter => filterBy(filter, filters[filter])(model))
            .filter(hasMatch => !hasMatch)
            .length === 0;
    });

    return models;
}

/**
 * Sorts the data
 * @param {Array} models
 * @param {Object} queryParams
 */
export function sort(models, queryParams) {
    const { sort } = queryParams;

    if (!sort) {
        return models;
    }

    const sorter = (field, asc) => (a, b) => {
        if (a[field] < b[field]) {
            return asc ? -1 : 0;
        }

        if (a[field] > b[field]) {
            return asc ? -0 : -1;
        }

        return 0;
    };

    return models.sort(sorter(sort.replace('-', ''), sort.startsWith('-')));
}

/**
 * Paginates the data
 * @param {Array} models
 * @param {Object} queryParams
 */
export function paginate(models, queryParams) {
    const pageSize = parseInt(queryParams.pageSize) || 10;
    const page = parseInt(queryParams.page) || 1;
    const start = page === 1
        ? 0
        : page * pageSize;

    return {
        currentPage: page,
        data: models.slice(start, start + pageSize),
        total: models.length,
        count: pageSize,
        perPage: pageSize,
        totalPages: models.length / (pageSize),
    };
}

/**
 * Applies filter, sort and optional extra filter and returns it paginated
 * @param {Array} models
 * @param {Object} queryParams
 * @param {Function} extraFilter
 */
export function apply(models, queryParams, extraFilter) {
    if (extraFilter) {
        models = models.filter(extraFilter);
    }

    models = filter(models, queryParams);
    models = sort(models, queryParams);


    return paginate(models, queryParams);
}